const root = `td-user/`
const urls = {
  getInfo: root + 'info',
  getUserList: root + 'page',
  getUserDetail: root + 'detail',
  remove: root + 'remove',
  add: root + 'submit',
  detail: root + 'detail',
  update: root + 'update'
}

export const getInfo = obj => {
  return $http.get(urls.getInfo, obj)
}

export const getUserList = obj => {
  return $http.get(urls.getUserList, obj)
}
export const getUserDetail = id => {
  return $http.get(urls.getUserDetail, { id: id })
}
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(urls.remove + `?ids=${ids}`)
}
export const add = obj => {
  return $http.post(urls.add, obj)
}
export const detail = id => {
  return $http.get(urls.detail, { id: id })
}
export const update = obj => {
  return $http.post(urls.update, obj)
}
export const exportFile = () => {
  return $http.export('http://10.32.2.177:9000/000000-xzcf/upload/20210712/881d77d9f290eac848cfb3ccf4c7ad10.pdf')
}
export default {
  getInfo,
  getUserList,
  getUserDetail,
  remove,
  add,
  detail,
  update
}
